var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[(_vm.showHowto)?_c('Howto',{on:{"close":_vm.hideHowto}}):_vm._e(),_c('Logo'),_c('Cigarette'),_c('BottomBar'),_c('PlayButton',{attrs:{"ready":_vm.isReadyToPlay},nativeOn:{"click":function($event){return _vm.start.apply(null, arguments)}}}),(_vm.showSummary)?_c('Summary'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }